import { useState, useEffect } from 'react';
import { useParams, useSearchParams, Link } from 'react-router-dom';
import ProductCard from '../../components/ProductCard/ProductCard';
import { useProducts, useCategories } from '../../hooks/useProducts';
import './CataloguePage.css';

import { useDocumentTitle } from '../../hooks/useDocumentTitle';
export default function CataloguePage() {
  useDocumentTitle('Catalogue');

  const { categorie }  = useParams();
  const [searchParams] = useSearchParams();
  const q              = searchParams.get('q') || '';
  const categories     = useCategories();
  const [prixMin, setPrixMin] = useState('');
  const [prixMax, setPrixMax] = useState('');
  const [tri, setTri]         = useState('defaut');
  const [page, setPage]       = useState(1);

  useEffect(() => setPage(1), [categorie, q, prixMin, prixMax]);

  const { products, total, pages, loading } = useProducts({
    categorie: categorie || '', q,
    prix_min: prixMin || undefined,
    prix_max: prixMax || undefined,
    page, limit: 12,
  });

  const produitsTries = [...products].sort((a, b) => {
    if (tri === 'prix_asc')  return a.prix - b.prix;
    if (tri === 'prix_desc') return b.prix - a.prix;
    if (tri === 'nom')       return a.nom.localeCompare(b.nom);
    return 0;
  });

  const label = categorie
    ? (categories.find(c => c.slug === categorie)?.nom || categorie)
    : q ? `Résultats pour "${q}"` : 'Toute la collection';

  return (
    <div className="catalogue">
      <div className="catalogue__hero">
        <div className="container">
          <p className="catalogue__overtitle">Les Bazars de Keassa</p>
          <h1 className="catalogue__titre">{label}</h1>
        </div>
      </div>
      <div className="container catalogue__body">
        <aside className="catalogue__filters">
          <h2 className="catalogue__filters-titre">Filtres</h2>
          <div className="catalogue__filter-group">
            <p className="catalogue__filter-label">Catégorie</p>
            <Link to="/catalogue" className={`catalogue__filter-link${!categorie ? ' active' : ''}`}>Tout</Link>
            {categories.map(c => (
              <Link key={c.slug} to={`/catalogue/${c.slug}`}
                className={`catalogue__filter-link${categorie === c.slug ? ' active' : ''}`}>{c.nom}</Link>
            ))}
          </div>
          <div className="catalogue__filter-group">
            <p className="catalogue__filter-label">Prix (€)</p>
            <div className="catalogue__price-range">
              <input type="number" min="0" placeholder="Min" value={prixMin}
                onChange={e => setPrixMin(e.target.value)} aria-label="Prix minimum" />
              <span>—</span>
              <input type="number" min="0" placeholder="Max" value={prixMax}
                onChange={e => setPrixMax(e.target.value)} aria-label="Prix maximum" />
            </div>
            {(prixMin || prixMax) && (
              <button className="catalogue__filter-reset"
                onClick={() => { setPrixMin(''); setPrixMax(''); }}>Réinitialiser</button>
            )}
          </div>
        </aside>
        <div className="catalogue__main">
          <div className="catalogue__toolbar">
            <p className="catalogue__count">{loading ? 'Chargement...' : `${total} article${total > 1 ? 's' : ''}`}</p>
            <select className="catalogue__sort" value={tri} onChange={e => setTri(e.target.value)}>
              <option value="defaut">Trier par : Défaut</option>
              <option value="prix_asc">Prix croissant</option>
              <option value="prix_desc">Prix décroissant</option>
              <option value="nom">Nom A → Z</option>
            </select>
          </div>
          {loading ? <div className="spinner" /> : produitsTries.length > 0 ? (
            <div className="products-grid">
              {produitsTries.map(p => <ProductCard key={p.id} produit={p} />)}
            </div>
          ) : (
            <div className="catalogue__empty">
              <p>Aucun produit trouvé.</p>
              <Link to="/catalogue" className="btn-outline" style={{ marginTop: 16, display: 'inline-flex' }}>Voir tout</Link>
            </div>
          )}
          {pages > 1 && (
            <div className="catalogue__pagination">
              {Array.from({ length: pages }, (_, i) => i + 1).map(p => (
                <button key={p} onClick={() => setPage(p)}
                  className={`catalogue__page-btn${p === page ? ' active' : ''}`}>{p}</button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}